import { Reveal } from "@/components/site/Reveal";
import { MapPin } from "lucide-react";
import { SITE } from "@/site";

export const ServiceArea = () => (
  <section id="areas" className="py-24 md:py-32 bg-[#020617]">
    <div className="mx-auto max-w-7xl px-5 md:px-10">
      <Reveal>
        <span className="font-mono-label text-[11px] text-[#FACC15]">Where I train</span>
        <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl mt-4 max-w-3xl">
          Based in Chelmsford, <span className="text-[#FACC15]">covering Essex.</span>
        </h2>
        <p className="text-[#94A3B8] max-w-xl mt-5 text-base md:text-lg">
          I travel to you across much of Essex. If your town isn't listed, get in touch — chances
          are I can still reach you.
        </p>
      </Reveal>

      <div className="flex flex-wrap gap-3 mt-12">
        {SITE.towns.map((town, i) => (
          <Reveal key={town} delay={i * 0.03}>
            <span
              data-testid={`area-${i}`}
              className="inline-flex items-center gap-2 px-5 py-3 rounded-full border border-white/10 text-[#F8FAFC] hover:border-[#FACC15]/60 hover:text-[#FACC15] transition-colors duration-300"
            >
              <MapPin size={14} className="text-[#FACC15]" />
              <span className="font-display text-base md:text-lg">{town}</span>
            </span>
          </Reveal>
        ))}
        <Reveal delay={SITE.towns.length * 0.03}>
          <span className="inline-flex items-center px-5 py-3 rounded-full bg-[#FACC15]/10 border border-[#FACC15]/30 text-[#FACC15] font-display text-base md:text-lg">
            + surrounding towns & villages
          </span>
        </Reveal>
      </div>
    </div>
  </section>
);
